/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deck_Upload_PasteInputs */



/**
* | output |
* | --- |
* | "Paste Deck" |
*
* @param {Deck_Upload_PasteInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_upload_paste = /** @type {((inputs?: Deck_Upload_PasteInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Upload_PasteInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Coller un Deck")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pegar Deck")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Colar Deck")
	if (locale === "it") return /** @type {LocalizedString} */ ("Incolla Deck")
	return /** @type {LocalizedString} */ ("Paste Deck")
});